<template>
  <div class="tbp">
    <notice v-if="$store.getters.checkNotice" />
    <paymentStatus :orderDetails="orderDetails" />
    <refund
      refundTicket="hmtRefundDetailsEn"
      :itemList="orderDetails.itemList"
      v-if="orderDetails.itemList && orderDetails.itemList.some(v => v.ticketStatus === '5')"
    >
    </refund>
    <main>
      <idType v-if="Object.keys(orderDetails).length" :orderDetails="orderDetails" />
      <ticketState
        :itemList="orderDetails.itemList"
        v-if="!(orderDetails.status === '3') && !(orderDetails.status === '0')"
      />
      <oddt :orderDetails="orderDetails" />
      <atourist v-if="orderDetails.status === '0'" :itemList="orderDetails.itemList" />
    </main>
    <explain :itemList="orderDetails.itemList" />
    <paytabber
      :ticketlist="ticketlist"
      tickettype="touristorderdetailsEn"
      :payCloseTime="orderDetails.payCloseTime"
      v-if="orderDetails.status == '0'"
    />
    <again
      :ticketlist="ticketlist"
      refundTicketPath="hmtRefundListEn"
      v-else-if="orderDetails.status == '1'"
      :orderDetails="orderDetails"
    />
    <complete
      :orderDetails="orderDetails"
      :ticketlist="ticketlist"
      :base="orderDetails.itemList"
      :orderId="orderId"
      v-else-if="orderDetails.status == '2' || orderDetails.status == '3'"
    />
    <againTicketPurchase :ticketlist="ticketlist" v-else-if="orderDetails.status == '4'" />
  </div>
</template>

<script>
import idType from "@/components/orderEn/orderdetails/idType";
import ticketState from "@/components/orderEn/orderdetails/ticketState";
import paymentStatus from "@/components/orderEn/orderdetails/paymentStatus";
import explain from "@/components/orderEn/orderdetails/explain";
import oddt from "@/components/orderEn/orderdetails/oddt";
import atourist from "@/components/orderEn/orderdetails/atourist";
import paytabber from "@/components/orderEn/orderdetails/payTabber";
import again from "@/components/orderEn/orderdetails/again";
import complete from "@/components/orderEn/orderdetails/complete";
import againTicketPurchase from "@/components/orderEn/orderdetails/againTicketPurchase";
import refund from "@/components/orderEn/orderdetails/refund";
import { getIndividualOrderSingle } from "@/service/order/touristOrderDetails.js";

export default {
  name: "touristOrderDetailsEn",
  data() {
    return {
      orderDetails: {},
      websorket: null,
      orderId: "",
      onceTime: null,
      ticketlist: ""
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    async getdata() {
      // Instructions for use
      // 票状态
      // - 0 待出票
      // - 1 未激活
      // - 2 未使用(未完成)
      // - 3 部分使用
      // - 4 已使用  (or满足某些条件后前端自动改为已逾期)
      // - 5 已退票
      const { orderId } = this.$route.query;
      const { data } = await getIndividualOrderSingle.call(this, {
        id: orderId
      });
      const ticketStatusNames = [
        "Ticket to be issued",
        "To be activated",
        "Unused",
        "Partially used",
        "Used",
        "Refunded"
      ];
      if (data.status === "0" || data.status === "1") this.controlSorket();
      // 额外增加日期判断业务，随时可删，增加已逾期状态
      data.itemList.forEach(item => {
        item.ticketStatusName = ticketStatusNames[item.ticketStatus];
        item.attrList.forEach(v => (v.cerNo = this.$hiddenCardId(v.cerNo, 4, 4)));
        if (item.ticketStatus === "2" && item.canRefund === "0") {
          const starttime = new Date(item.refundCloseTime.replace(/-/g, "/"));
          const curtime = new Date();
          if (starttime < curtime) {
            item.ticketStatus = "4";
            item.ticketStatusName = "Expired";
          }
        }
      });
      this.orderDetails = data;
      this.initializationTicketlist(this.orderDetails.itemList[0].ticketSn);
      this.mergeOliver();
    },
    initializationTicketlist(ticketSn) {
      let rootTouristtype = "buytickethomeEn";
      let touristtype = 0;
      let ticketpurchase = 0;
      let buyList = [
        this.$store.state.ticketWindow.hmtticketlistWindowListEn,
        this.$store.state.ticketWindow.qnd2ticketlistWindowListEn
      ];
      buyList.forEach(item => {
        let ticketObj = item.find((tickets, i) => {
          if (tickets.totalOffPeakSeasonProductSns.includes(ticketSn)) {
            ticketpurchase = i;
          }
          return tickets.totalOffPeakSeasonProductSns.includes(ticketSn);
        });
        if (ticketObj) {
          // console.log(ticketObj);
          rootTouristtype = ticketObj.rootTouristtype;
        }
      });

      // console.log(Object.values({
      //   hmtticketlistWindowListEn: this.$store.state.ticketWindow.hmtticketlistWindowListEn,
      //   qnd2ticketlistWindowListEn: this.$store.state.ticketWindow.qnd2ticketlistWindowListEn
      // }))
      // console.log(`/${rootTouristtype}/${touristtype}/${ticketpurchase}`);
      this.ticketlist = `/${rootTouristtype}/${touristtype}/${ticketpurchase}`;
    },
    controlSorket() {
      const { orderId } = this.$route.query;
      this.websorket = new WebSocket(process.env.VUE_APP_WEBSORKET_BASE_URL + orderId);
      const hearCheck = {
        timeout: 10000,
        timeoutObj: {},
        reset: () => {
          clearInterval(this.timeoutObj);
        },
        start: () => {
          this.timeoutObj = setInterval(() => {
            this.websorket.send("nowDate" + Date());
          }, hearCheck.timeout);
        }
      };
      const createLink = () => {
        hearCheck.reset();
        hearCheck.start();
      };
      this.websorket.onopen = createLink;
      this.websorket.onmessage = event => {
        const data = event.data && JSON.parse(event.data);
        if (data) {
          this.getdata();
          if (data.statusName == "5") {
            this.$toast("Refund Application Successsful");
          }
          this.$loading.loadingStata = false;
        }
      };
      this.websorket.onerror = createLink;
    },
    mergeOliver() {
      if (Object.keys(this.orderDetails).length && this.$store.state.oliver.length) {
        const orderDetails = this.orderDetails;
        const mediumList = this.$store.state.oliver;
        orderDetails.itemList.forEach(ticket => {
          mediumList.some(medium => {
            if (ticket.ticketSn === medium.ticketSn && ticket.attrList.length === 1) {
              ticket.mediaType = "qr_code";
              ticket.openType = medium.openType;
              return true;
            }
          });
        });
      }
    }
  },
  components: {
    paymentStatus,
    idType,
    ticketState,
    explain,
    oddt,
    atourist,
    paytabber,
    again,
    complete,
    againTicketPurchase,
    refund
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timeoutObj);
    if (this.websorket) this.websorket.close();
    next();
  }
};
</script>

<style scoped lang="less">
.tbp {
  padding-bottom: 1.6rem + 0.346667rem;
  min-height: 100vh;
}
main {
  margin: 0 0.346667rem;
  background: #ffffff;
  box-shadow: 0px 0.133333rem 0.08rem rgba(0, 0, 0, 0.01);
  border-radius: 0.08rem;
  overflow: hidden;
}
</style>
